import './mobile-navigation.scss';

export default () => {
    document.addEventListener('click', function (event) {
        if (event.target.classList.contains('mobile-menu-toggle')) {
            if (document.body.classList.contains("menu-closed")) {
                document.body.classList.remove("menu-closed");
            }
            if (document.body.classList.contains("menu-open")) {
                document.body.classList.add("menu-closed");
            }
    
            // toggle menu open
            document.body.classList.toggle("menu-open");
        }
    });
    
    function submenutoggle() {
        var subMenuButtons = document.querySelectorAll("button.sub-menu-toggle");
        subMenuButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                this.classList.toggle('open');
                var menuItem = this.parentNode;
                
                // Use nextElementSibling to get the next sibling (sub-menu)
                var menuItemSub = this.nextElementSibling;
                
                // Check if the next sibling exists and has the class 'sub-menu'
                if (menuItemSub && menuItemSub.classList.contains('sub-menu')) {
                    menuItemSub.classList.toggle('open');
                }
            });
        });
    
        var menuItems = document.querySelectorAll('li.menu-item-has-children a[href*="#"]');
        menuItems.forEach(function (menuItem) {
            menuItem.addEventListener('click', function (event) {
                event.preventDefault();
                var target = this.getAttribute('href');
                if (target === '#') {
                    var parentMenuItem = this.parentNode;
                    
                    // Again, use nextElementSibling to get the next sub-menu
                    var menuItemSub = this.nextElementSibling;
                    var menuItemSubButton = parentMenuItem.querySelector('button.sub-menu-toggle');
                    
                    if (menuItemSub && menuItemSub.classList.contains('sub-menu')) {
                        menuItemSub.classList.toggle('open');
                    }
                    if (menuItemSubButton) {
                        menuItemSubButton.classList.toggle('open');
                    }
                }
            });
        });
    }
    
    submenutoggle();
};